import useTranslationWithFallback from './use-translation-with-fallback';


const useAllergens = (translations = {}) => {
  const { t } = useTranslationWithFallback('common');

  const allergens = [
    {
      icon: 'vegetarian-diet',
      id: 'vegetarian-diet',
      labelKey: 'allergens.vegetarian'
    },
    {
      icon: 'vegan-diet',
      id: 'vegan-diet',
      labelKey: 'allergens.vegan'
    },
    {
      icon: 'gluten-free-diet',
      id: 'gluten-free-diet',
      labelKey: 'allergens.gluten_free'
    },
    {
      icon: 'lactose-intolerance',
      id: 'lactose-intolerance',
      labelKey: 'allergens.lactose_intolerance'
    },
    {
      icon: 'kosher',
      id: 'kosher',
      labelKey: 'allergens.kosher'
    },
    {
      icon: 'low-calories',
      id: 'low-calories',
      labelKey: 'allergens.low_calories'
    },
    {
      icon: 'sugar',
      id: 'sugar',
      labelKey: 'allergens.sugar'
    },
    {
      icon: 'tree-nuts',
      id: 'tree-nuts',
      labelKey: 'allergens.tree_nuts'
    }
  ];

  return allergens.map(allergen => ({
    ...allergen,
    checked: false,
    label: translations?.[allergen.id] || t(allergen.labelKey)
  }));
};

export default useAllergens;
